var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("hr"),
      _vm._v(" "),
      _c("settings-property", {
        attrs: {
          label: _vm.resource(
            "JourneyComposer_BrickSettingsAudienceFilter_ConditionName_DisplayName"
          )
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function(ref) {
              var id = ref.id
              return [
                _c("input-group", { attrs: { icon: "far fa-edit" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.nameModel,
                        expression: "nameModel"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", id: id, disabled: !_vm.canWrite },
                    domProps: { value: _vm.nameModel },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.nameModel = $event.target.value
                      }
                    }
                  })
                ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("settings-property", {
        attrs: {
          label: _vm.resource(
            "JourneyComposer_BrickSettingsAudienceFilter_ConditionColor_DisplayName"
          )
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c("color-picker", {
                  attrs: {
                    color: _vm.colorModel,
                    "last-color": _vm.lastColor,
                    enabled: _vm.canWrite
                  },
                  on: {
                    "change-color": function($event) {
                      _vm.colorModel = $event
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("settings-property", {
        attrs: {
          label: _vm.resource(
            "JourneyComposer_BrickSettingsAudienceFilter_ConditionFields_DisplayName"
          )
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c("id-dispenser", {
                  attrs: { elements: _vm.fieldsModel },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var idsPerElement = ref.idsPerElement
                        return [
                          _vm._l(_vm.fieldsModel, function(field, index) {
                            return [
                              _c(
                                "div",
                                { key: idsPerElement.get(field) },
                                [
                                  _c("audience-filter-brick-condition-field", {
                                    attrs: {
                                      fields: _vm.fieldTypes,
                                      value: field.value,
                                      type: field.type
                                    },
                                    on: {
                                      "update:value": function($event) {
                                        return _vm.$set(field, "value", $event)
                                      },
                                      "update:type": function($event) {
                                        return _vm.$set(field, "type", $event)
                                      },
                                      delete: function($event) {
                                        return _vm.deleteFieldAt(index)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          })
                        ]
                      }
                    }
                  ])
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-4" }),
        _vm._v(" "),
        _c("div", { staticClass: "col-8" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-secondary",
              attrs: { disabled: !_vm.canWrite },
              on: { click: _vm.addField }
            },
            [
              _c("i", { staticClass: "fas fa-plus" }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.resource(
                      "JourneyComposer_BrickSettingsAudienceFilter_AddField_DisplayName"
                    )
                  ) +
                  "\n            "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-8" }),
        _vm._v(" "),
        _c("div", { staticClass: "col-4" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-danger btn-icon-left w-100",
              attrs: { disabled: !_vm.canWrite },
              on: {
                click: function($event) {
                  return _vm.$emit("delete")
                }
              }
            },
            [
              _c("i", { staticClass: "fa fa-trash" }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.resource(
                      "JourneyComposer_BrickSettingsAudienceFilter_RemoveCondition_DisplayName"
                    )
                  ) +
                  "\n            "
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }